// UserManagementConstants.js

/**
 * @const UserManagementConstants
 */
const UserManagementConstants = {
  REQUEST_USER_DETAILS: 'REQUEST_USER_DETAILS',
  REQUEST_USER_DETAILS_SUCCESS: 'REQUEST_USER_DETAILS_SUCCESS',
  REQUEST_USER_DETAILS_ERROR: 'REQUEST_USER_DETAILS_ERROR',
};

export default UserManagementConstants;
